import useSWR from "swr";

import { ArtRow } from "../components/KbCards";
import { Icon } from "../components/Icon";
import { api, type KbArticleListItem } from "../services/api";

/** Recently-viewed articles. */
export function KbRecent() {
  const { data } = useSWR<KbArticleListItem[]>("/api/kb/recent", () => api.kb.recent());
  const items = data ?? [];
  return (
    <div className="kb-page">
      <div className="page-header">
        <h1 className="page-title">Recently Viewed</h1>
        <p className="page-subtitle">Pick up where you left off.</p>
      </div>
      {items.length > 0 ? (
        <div className="kb-art-list">
          {items.map((a) => (
            <ArtRow key={a.id} article={a} />
          ))}
        </div>
      ) : (
        <div className="kb-empty">
          <div className="kb-empty-ico">
            <Icon name="clock" size={26} />
          </div>
          <h3>No history yet</h3>
          <p>Articles you open will appear here so you can find them again easily.</p>
        </div>
      )}
    </div>
  );
}

export default KbRecent;
